import { useCallback } from 'react';
import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import EyeIcon from 'assets/images/icons/eye.svg?react';
import Button from 'components/button/Button';
import Tooltip from 'components/tooltip/Tooltip';
import { MessageLog } from 'models/automation/MessageLogs';
import { useNavigate } from 'react-router-dom';
import { ActionsCellStyled } from '../MessageLogTable.styles';

const ActionsCell = ({ row }: { row: Row<MessageLog> }) => {
  const { t } = useTranslation();
  const { uid: messageLogUid } = row.original;
  const navigate = useNavigate();

  const navigateToViewMessageLogPage = useCallback(() => {
    navigate(`./${messageLogUid}`);
  }, [navigate, messageLogUid]);

  return (
    <ActionsCellStyled>
      <Tooltip id="row-view-message-button" text={t('common.view')}>
        <Button
          bsStyle="link"
          data-testid="row-view-message-button"
          onClick={navigateToViewMessageLogPage}
        >
          <EyeIcon aria-label={t('common.view')} />
        </Button>
      </Tooltip>
    </ActionsCellStyled>
  );
};

export default ActionsCell;
